export default __webpack_public_path__ + "locales/ru/InviteDialog.json?hash=c801c36115cb5ac93077d272ace2cb06";